class FilterMenu {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-scope="filters"]',
			open: '[data-filter-menu="open"]',
			close: '[data-filter-menu="close"]',
			menu: '[data-filter-menu="menu"]',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		this.$scope.on('click', this.config.open, this.open.bind(this));
		this.$scope.on('click', this.config.close, this.close.bind(this));
	}

	open(event) {
		event.preventDefault();
		let $button = $(event.currentTarget);
		$('body').addClass('filters-open');
	}

	close() {
		event.preventDefault();
		let $button = $(event.currentTarget);
		$('body').removeClass('filters-open');
	}
}

export default new FilterMenu;